import { Button, CircularProgress } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import ProductHeader from "../ProductDetails/ProductHeader";
import { ReactComponent as Password } from "./../GridView/assets/password.svg";
import TextField from "@material-ui/core/TextField";
// import { Unstable_NumberInput as NumberInput } from "@mui/base/Unstable_NumberInput";
import instance from "../../store/actions/instance";

function PasswordPage({ language, distributor, onValidation, customTexts }) {
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState(false);
  const [validateLoading, setValidateLoading] = React.useState(false);

  const validate = async () => {
    setError(false);
    setValidateLoading(true);
    try {
      const res = await instance.post("/validate_distributor_password/", {
        distributor_id: distributor.id,
        password: password,
      });
      if (res.data.success == true) {
        onValidation(true);
      } else setError(true);
    } catch (err) {
      console.error(err);
    }
    setValidateLoading(false);
  };

  return (
    <div
      className=""
      style={{ backgroundColor: "white", minHeight: window.innerHeight }}
    >
      <div className="free-space-80" style={{ backgroundColor: "white" }}></div>

      <Password style={{ width: 150, height: 150, marginTop: "10vh" }} />
      <p style={{ margin: "auto", marginTop: 15, maxWidth: "90%" }}>
        {language == "english"
          ? customTexts.b2b_password
          : customTexts.b2b_password_ar}
      </p>

      <TextField
        id="standard-password-input"
        label={language == "english" ? "Password" : "كلمة المرور"}
        type="number"
        autoComplete="current-password"
        className="mb-3 mt-3"
        style={{
          minWidth: 280,
          direction: language == "english" ? "ltr" : "rtl",
        }}
        onChange={(e) => {
          setPassword(e.target.value);
          setError(false);
        }}
        error={error && password.length > 0}
        helperText={
          error && password.length > 0
            ? language === "english"
              ? "Incorrect password"
              : "كلمة مرور خاطئة"
            : ""
        }
        FormHelperTextProps={{
          style: {
            textAlign: language == "english" ? "left" : "right",
          },
        }}
        InputLabelProps={{
          style: {
            transformOrigin: language == "english" ? "top left" : "top right",
            right: language == "arabic" ? 0 : "unset",
            left: language == "english" ? 0 : "unset",
          },
        }}
        onKeyDown={(e) => {
          if (password.length == 0 || validateLoading) return;
          if (e.keyCode === 13) {
            validate();
          }
        }}
      />

      <div className="mt-3">
        <Button
          variant="contained"
          disabled={password.length == 0 || validateLoading}
          color="primary"
          style={{ width: 100 }}
          onClick={() => validate()}
        >
          {validateLoading === false ? (
            language === "english" ? (
              "Enter"
            ) : (
              "دخول"
            )
          ) : (
            <CircularProgress size={40} />
          )}
        </Button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    customTexts: state.store.store.settings.custom_texts,
  };
};
export default connect(mapStateToProps)(PasswordPage);
